import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language.service';
import { CustomNgbDateParserFormatter } from '../models/custom-ngb-date-parser-formatter';

/**
 * Custom implementation of NgbDatepickerI18n (ng-bootstrap/datepicker)
 *
 * @export
 * @class ClxDatepickerI18nService
 * @extends {NgbDatepickerI18n}
 */
@Injectable()
export class ClxDatepickerI18nService extends NgbDatepickerI18n {

  constructor(private language: LanguageService, private translate: TranslateService) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return this.language.getWeekdayShortName(weekday);
  }

  getMonthShortName(month: number, year?: number): string {
    return this.language.getMonthShortName(month);
  }

  getMonthFullName(month: number, year?: number): string {
    return this.language.getMonthFullName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return this.language.getDayAriaLabel(CustomNgbDateParserFormatter.toDate(date));
  }

}
